<template>
    <div class="company-article">
        <dl id="dl_en" class="hide">
        <dd>The consumer plays an important role in tyre maintenance. Tyres may have to removed from service for numerous reasons, including tread worn down to minimum depth, damage or abuse (punctures, cuts, impacts, cracks, bulges, underinflation, overloading, etc). For these reasons tyres, including spares, must be inspected routinely, i.e., at least once a month.</dd>
        <dd>Regular inspection becomes particularly important the longer a tyre is kept in service. If tyre damage is suspected or found, ARIVO recommends that the consumer have the tyre inspected by a tyre service professional. Consumers should use this consultation to determine if the tyres can continue in service. It is recommended that spare tyres be inspected at the same time. This routine inspection should occur whether or not the vehicle is equipped with a tyre pressure monitoring system (TPMS).</dd>
        <dd>Consumers are strongly encouraged to be aware of their tyres’ visual condition. Also, they should be alert for any change in dynamic performance such as increased air loss, noise or vibration. Such changes could be an indicator that one or more of the tyres should be immediately removed from service to prevent a tyre disablement.</dd>
        <dt>TYRE PRESSURE</dt>
        <dd>Tyre pressure should be treated as an important safety element of your car’s tyre maintenance. It is vital that your car has the correct tyre pressure as it is required to carry the weight of your car and its load. There’s no excuse for not having the correct tyre pressure as you can easily top it up at nearly every service station.</dd>
        <dt>TYRE ALIGNMENT</dt>
        <dd>Tyre alignment involves putting your car wheels at perpendicular angles to the ground and parallel to each other. By having your tyres properly aligned, you can increase tyre life and keep your car straighter on the road. It isn’t actually your tyres that are adjusted when fixing tyre alignment but the vehicle’s suspension. By adjusting the suspension, it affects how the tyres make contact with the road.</dd>
        <dt>TYRE BALANCING</dt>
        <dd>Wheel balancing refers to the distribution of weight in a car tyre or wheel. Car owners usually get their tyres balanced at the same time as wheel alignment. Your car’s tyre balancing is measured by placing your tyre on a balancing machine. The tyre is then spun at a high speed to measure any imbalances. It also informs the mechanic of how much weight is required to balance out the tyre and where the extra weight needs to be positioned. The wheels are then balanced by placing a weight on the opposite site to where a heavy spot it located.</dd>
        </dl>
        <dl id="dl_cn" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_es" class="hide">
            <dd>test</dd>
        </dl>
        <dl id="dl_ru" class="hide">
            <dd>test</dd>
        </dl>
    </div>
</template>
<script>
import $ from "jquery";
import Constants from "../../consts";
import VueCookies from "vue-cookies";
import consts from "../../consts";
export default {
  name: "Maintenance_Content",
  mounted: function() {
      $("#dl_en").addClass("show").removeClass("hide");
    // let lang = VueCookies.get(consts.COOKIE_LANG);
    // if (lang) {
    //   $("#dl_" + lang)
    //     .addClass("show")
    //     .removeClass("hide");
    // } else {
    //   $("#dl_en")
    //     .addClass("show")
    //     .removeClass("hide");
    // }
  }
};
</script>
<style>
.hide {
  display: none;
}
.show {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/service/maintenance_content.vue